import React, { useState } from "react";
import { Tooltip } from "antd";
import { NavLink } from "react-router-dom";
const MAXLENGTH_TITLE = 40;
const MAXLENGTH_TITLE_SMALL_SCREENS = 15;
const SMALL_SCREEN_SIZE = 425;

function FormatTitle(props) {
  if (typeof props.title !== "string") return null;

  const { currentViewWidth } = props;
  let maxLength;
  if (currentViewWidth <= SMALL_SCREEN_SIZE) {
    maxLength = MAXLENGTH_TITLE_SMALL_SCREENS;
  } else {
    maxLength =
      !props.maxLength || typeof props.maxLength !== "number"
        ? MAXLENGTH_TITLE
        : props.maxLength;
  }

  const title = props.title;
  const dotsStr = "...";
  if (title.length <= maxLength) {
    return (
      <React.Fragment>
        {" "}
        <h2>{title}</h2>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Tooltip title={title}>
        <h2>{title.slice(0, maxLength - dotsStr.length).concat(dotsStr)}</h2>
      </Tooltip>
    </React.Fragment>
  );
}

function CloseButton(props) {
  return (
    <React.Fragment>
      <div onClick={props.onClick}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4614 12.2165C10.7039 12.4602 11.0226 12.5815 11.3414 12.5815C11.6601 12.5815 11.9788 12.4602 12.2213 12.2165C12.7076 11.7302 12.7076 10.9415 12.2213 10.4553L2.26527 0.489192C1.77903 0.00295153 0.991547 0.00295153 0.505306 0.489192C0.0190648 0.975433 0.0190648 1.76417 0.505306 2.25041L10.4614 12.2165Z"
            fill="white"
          ></path>
          <path
            d="M18.0802 16.3189L32.1362 2.2504C32.6225 1.76416 32.6225 0.975425 32.1362 0.489184C31.65 0.0029427 30.8625 -0.212053 30.3763 0.275438L15.4415 15.0089H15.0716V15.4402L0.321827 30.3874C-0.164413 30.8736 -0.0719153 31.6624 0.413076 32.1486C0.655571 32.3923 1.02056 32.5136 1.33931 32.5136C1.65805 32.5136 1.9993 32.3923 2.24179 32.1486L16.309 18.0814L30.37 32.1498C30.6125 32.3936 30.935 32.5148 31.2525 32.5148C31.57 32.5148 31.8912 32.3936 32.1337 32.1498C32.62 31.6636 32.6212 30.8749 32.135 30.3886L18.0802 16.3189Z"
            fill="white"
          ></path>
        </svg>
      </div>
    </React.Fragment>
  );
}

export default function CollectionMiddleViewHeader(props) {
  const {
    itemSelected,
    breadCrumbs,
    handleOnPrev,
    handleOnNext,
    handleUnselectedItem,
    vhClose,
    currentViewWidth,
    data,
    handleSelectFolderExplore
  } = props;

  let idItemSelected = itemSelected.name;
  const indexItems = data
    .map(arrayItem => arrayItem.name)
    .indexOf(idItemSelected);

  const [prevItemState] = useState(
    indexItems !== 0 ? data[indexItems - 1].name : data[data.length - 1].name
  );
  const [nextItemState] = useState(
    indexItems !== data.length - 1 ? data[indexItems + 1].name : data[0].name
  );

  return (
    <React.Fragment>
      <div className="closebutton-bunkey" onClick={vhClose}>
        <CloseButton onClick={handleUnselectedItem} />
      </div>
      <div className="bb-box-edit__title">
        <div className="bb-box-edit__bradcrumb">
          <ul>
            <span>/</span>
            {breadCrumbs.map((r, k) => (
              <li key={k}>
                <NavLink
                  to={`/home/explore/${r.id}`}
                  onClick={() => {
                    handleSelectFolderExplore(r.id);
                  }}
                >
                  {r.name}/
                </NavLink>
              </li>
            ))}
          </ul>
          <FormatTitle
            title={itemSelected.name}
            currentViewWidth={currentViewWidth}
          />
        </div>

        <div className="media-actions">
          {/* <div className="close-button" onClick={handleUnselectedItem}>
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4614 12.2165C10.7039 12.4602 11.0226 12.5815 11.3414 12.5815C11.6601 12.5815 11.9788 12.4602 12.2213 12.2165C12.7076 11.7302 12.7076 10.9415 12.2213 10.4553L2.26527 0.489192C1.77903 0.00295153 0.991547 0.00295153 0.505306 0.489192C0.0190648 0.975433 0.0190648 1.76417 0.505306 2.25041L10.4614 12.2165Z" fill="white" /><path d="M18.0802 16.3189L32.1362 2.2504C32.6225 1.76416 32.6225 0.975425 32.1362 0.489184C31.65 0.0029427 30.8625 -0.212053 30.3763 0.275438L15.4415 15.0089H15.0716V15.4402L0.321827 30.3874C-0.164413 30.8736 -0.0719153 31.6624 0.413076 32.1486C0.655571 32.3923 1.02056 32.5136 1.33931 32.5136C1.65805 32.5136 1.9993 32.3923 2.24179 32.1486L16.309 18.0814L30.37 32.1498C30.6125 32.3936 30.935 32.5148 31.2525 32.5148C31.57 32.5148 31.8912 32.3936 32.1337 32.1498C32.62 31.6636 32.6212 30.8749 32.135 30.3886L18.0802 16.3189Z" fill="white" /></svg>
                    </div> */}
          <div className="bb-box-edit__arrows mt-1">
            <Tooltip placement="top" title={prevItemState}>
              <div className="arrow-prev" onClick={handleOnPrev}>
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 1L1.27083 6.5L7 12"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Tooltip>
            <Tooltip placement="top" title={nextItemState}>
              <div className="arrow-next" onClick={handleOnNext}>
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L6.72917 6.5L1 12"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      {/*FIN DIV TITLE */}
    </React.Fragment>
  );
}
